var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1122_161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1122_161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00088 6.69893L3.55088 9.14893C3.45921 9.24059 3.34255 9.28643 3.20088 9.28643C3.05921 9.28643 2.94255 9.24059 2.85088 9.14893C2.75921 9.05726 2.71338 8.94059 2.71338 8.79893C2.71338 8.65726 2.75921 8.54059 2.85088 8.44893L5.30088 5.99893L2.85088 3.54893C2.75921 3.45726 2.71338 3.34059 2.71338 3.19893C2.71338 3.05726 2.75921 2.94059 2.85088 2.84893C2.94255 2.75726 3.05921 2.71143 3.20088 2.71143C3.34255 2.71143 3.45921 2.75726 3.55088 2.84893L6.00088 5.29893L8.45088 2.84893C8.54255 2.75726 8.65921 2.71143 8.80088 2.71143C8.94255 2.71143 9.05921 2.75726 9.15088 2.84893C9.24255 2.94059 9.28838 3.05726 9.28838 3.19893C9.28838 3.34059 9.24255 3.45726 9.15088 3.54893L6.70088 5.99893L9.15088 8.44893C9.24255 8.54059 9.28838 8.65726 9.28838 8.79893C9.28838 8.94059 9.24255 9.05726 9.15088 9.14893C9.05921 9.24059 8.94255 9.28643 8.80088 9.28643C8.65921 9.28643 8.54255 9.24059 8.45088 9.14893L6.00088 6.69893Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseWhite);
export default __webpack_public_path__ + "static/media/ic_close_white.9c6f4ae6d7d23df58d8563616ff10dd5.svg";
export { ForwardRef as ReactComponent };